import ApiModule from './index'
import BaseModel from '../../base/BaseModel'

const MODULE = ApiModule.PAYMENT

export class QueryThirdPayTradeInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = MODULE
		this.url = '/payment/queryThirdPayTradeInfo'
		this.desc = '查询第三方支付交易信息提交'
	}
}

export class CreatePayOrderInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = MODULE
		this.url = '/payment/createPayOrderInfo'
		this.desc = '创建支付订单信息'
	}
}
